// components/Avatar.jsx
import React from "react";
import { useUserAvatar } from "../hooks/useUserAvatar";

export default function Avatar({ userId, size = 40, className = "" }) {
  // Obtiene en tiempo real la URL del avatar o el placeholder
  const avatarUrl = useUserAvatar(userId);
  const src = avatarUrl || "/img/avatar2.jpg";

  return (
    <img
      src={src}
      alt="Avatar"
      width={size}
      height={size}
      style={{
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  );
}
